<div mat-dialog-content>
  <div class="mat-dialog-content">
    <form class="form" [formGroup]="model">
      <div class="row">
        <div class="col-md-6">
          <div class="head-profile-modal-list">
            <h2>Procedimento: </h2>
          </div>
          <div class="body-confirm-modal-list">
            <div class="row">
              <div class="col-md-12">
                <label>Nome procedimento: </label>
                <p>{{procedure.procedureName}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>Observação: </label>
                <p>{{procedure.observation}}</p>
              </div>
            </div>
          </div>
        </div>
        @if (procedure.listMedicalProcedureCheck) {
          <div class="col-md-6">
            <div class="head-profile-modal-list">
              <h2>Histórico do Procedimento: </h2>
            </div>
            @for (item of procedure.listMedicalProcedureCheck; track item) {
              <div class="row">
                <div class="col-md-12">
                  @if (item.datetimeCheckFulfilled) {
                    <label>
                      Checado
                    </label>
                  }
                  <p>{{item.datetimeCheckFulfilled | date:'dd/MM/yyyy HH:mm'}}</p>
                  <p>{{item.professionName}} - {{item.userName}}</p>
                </div>
              </div>
            }
          </div>
        }
        <div class="footer-modal-list">
          @if (!isReadonly && data.actions) {
            <button mat-flat-button color="primary" class="btn-block" type="submit">
              @if (isLoading == false) {
                <span>Concluir</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
              }
            </button>
          }
          <button mat-flat-button type="button" color="primary" class="btn-block"
            (click)="close()"><span>Fechar</span></button>
          </div>
        </div>
      </form>
    </div>
  </div>